module.exports = __webpack_public_path__ + "images/emoji/maple_leaf.f0bacd3a479cac502b26.png";